module.exports = __webpack_public_path__ + "img/avtime.7cc2f87d.svg";